import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Slide1 from "./Images/Gaminiweb_02.png";
import { Helmet } from "react-helmet-async";
import './Website Development.css';
import {
    FaLaptopCode,
    FaRocket,
    FaLock,
    FaSearch,
    FaMobileAlt,
    FaExpandArrowsAlt
} from "react-icons/fa";
import {
    SiHtml5,
    SiCss3,
    SiReact,
    SiNodedotjs,
    SiWordpress,
    SiMongodb,
} from "react-icons/si";

const WebsiteDevelopment = () => {

    const navigate = useNavigate();
    return (
        <div className="webdev-container">

                     <Helmet>
  <title>Website Development Services - APTech Solution</title>
  <meta
    name="description"
    content="We provide professional website development services including static, dynamic, e-commerce, portfolio, and blog websites in Ankleshwar, Gujarat."
  />
</Helmet>




            {/* Hero Section */}
            <section className="hero-section">
                <h1>Website Development</h1>
                <p>We build modern, scalable, and responsive websites to grow your digital presence.</p>


                <img src={Slide1} alt="Website development banner" />
                {/* <img src="https://media4.giphy.com/media/v1.https://media3.giphy.com/media/v1.Y2lkPTc5MGI3Nhttps://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExejN0N25sNWM1dXlwbHhhZHpqY3p6djJncWh4Y3V3ZDQ3dTZnZjg5eiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/A6r7iEJW4MRDNoXoxJ/giphy.gifjExdHo0Njh6eGxpN2J6d3lyZWIwdjAydDRnN2hqcjJmZ3RqN2xqeHFkZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/r6z2DiggYdvY3lHAbX/giphy.gif/QusgpwtwWIluSZbPWp/giphy.gif://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExcWJnYnBxMmJtbGE1Mjhpcjd4aXp4YWc1cXAyMnNkMm1zeW55a2o0ciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/EZHzjkDCvL4V0h1KPs/giphy.gifhttps://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2cxZGVpcmk3aTF0NDFpMW4zYzRpd3lhOHoydjUzMDl4dGR0ZHpmNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/QusgpwtwWIluSZbPWp/giphy.gif" alt="Website development banner" /> */}
            </section>

            {/* Website Types Section */}
            <section className="website-types">
                <h2>Types of Websites We Build</h2>
                <div className="types-grid">
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/PortfolioWebsiteDevelopment')}

                    >
                        <h3>Portfolio Website</h3>
                    </div>
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/StaticWebsiteDevelopment')}

                    >
                        <h3>Static Website</h3>
                    </div>
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/DynamicWebsiteDevelopment')}

                    >
                        <h3>Dynamic Website</h3>
                    </div>
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/EcommerceWebsiteDevelopment')}

                    >
                        <h3> E-commerce Website</h3>
                    </div>
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/BlogWebsiteDevelopment')}

                    >
                        <h3>Blog Website</h3>
                    </div>
                    <div
                        className="highlight-card highlight-card3 highlight-card1"
                        onClick={() => navigate('/LandingPageDevelopment')}

                    >
                        <h3>Landing Page</h3>
                    </div>
                </div>
            </section>




            {/* Why Choose Us */}
            <section className="why-choose-us">
                <h2>Why Choose Us?</h2>

            </section>
            {/* Highlights */}

            <section className="highlights">


                <div className="highlight-card gradient-border-card">
                    <FaLaptopCode />
                    <h3>Responsive Design</h3>
                    <p>Seamless experience across all devices with mobile-first approach.</p>
                </div>
                <div className="highlight-card gradient-border-card">
                    <FaRocket />
                    <h3>Performance Optimized</h3>
                    <p>Lightning-fast loading speeds with optimized assets.</p>
                </div>
                <div className="highlight-card gradient-border-card">
                    <FaLock />
                    <h3>Secure Development</h3>
                    <p>Built with best security practices and HTTPS integrations.</p>
                </div>
                <div className="highlight-card gradient-border-card">
                    <FaExpandArrowsAlt />
                    <h3>Scalable & Future-Proof</h3>
                    <p>Flexible designs that grow with your business needs.</p>
                </div>
                <div className="highlight-card gradient-border-card">
                    <FaSearch />
                    <h3>SEO Ready</h3>
                    <p>Optimized for search engines to boost your visibility.</p>
                </div>
                <div className="highlight-card gradient-border-card">
                    <FaMobileAlt />
                    <h3>User-Friendly Interface</h3>
                    <p>Simple, intuitive, and smooth navigation experience.</p>
                </div>
            </section>

            {/* Development Process */}
            <section className="process-section">
                <h2>Our Development Process</h2>
                <div className="process-steps">
                    <div className="process-step">
                        <span className="step-number1">1</span>
                        <p><strong>Requirement Gathering:</strong> We thoroughly analyze your business goals, audience, and competitors to build a project blueprint that aligns with your vision.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number1">2</span>
                        <p><strong>Planning & Design:</strong> Wireframes, mood boards, and high-fidelity UI/UX designs are crafted collaboratively, focusing on user-centric layouts and branding.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number1">3</span>
                        <p><strong>Development:</strong> Our team writes clean, maintainable code with modern technologies. We build fully functional frontends and powerful backend systems, ensuring seamless integration.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number1">4</span>
                        <p><strong>Testing:</strong> We conduct rigorous testing for cross-browser compatibility, responsiveness, speed optimization, and bug fixing to deliver a flawless experience.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number1">5</span>
                        <p><strong>Deployment:</strong> Final product is deployed on a secure, scalable environment with proper setup of domains, SSL certificates, and essential configurations.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number1">6</span>
                        <p><strong>Support & Maintenance:</strong> We monitor performance, offer timely updates, and provide ongoing support for improvements, bug fixes, or feature enhancements.</p>
                    </div>
                </div>
            </section>



            {/* Tech Stack */}
            <section className="tech-stack">
                <h2>Technologies We Use</h2>
                <div className="tech-icons">
                    <SiHtml5 title="HTML5" />
                    <SiCss3 title="CSS3" />
                    <SiReact title="React" />
                    <SiNodedotjs title="Node.js" />
                    <SiWordpress title="WordPress" />
                    <SiMongodb title="MongoDB" />
                </div>
            </section>



            {/* CTA */}
            <section className="cta-section">
                <h2>Ready to Start Your Website?</h2>
                <p>Let’s bring your vision to life with a powerful and elegant website.</p>
                <Link to="/contact" state={{ scrollTo: "form" }}>
                    <button className="aboutpage-button">Contact Us Now</button>
                </Link>

            </section>
        </div>
    );
};

export default WebsiteDevelopment;
